module.exports = __webpack_public_path__ + "img/12.c73d2e40.png";